import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { SampleRow } from "./sampleRow";
import { useTranslation } from "react-i18next";

export default function InnerRow(props) {
  const {
    classes,
    rowData,
    samples,
    innerTableHeaders,
    userObj,
  } = props;

  const { t } = useTranslation();

  return (
    <div
      className={classes.innerTable}
      onClick={(event) => event.stopPropagation()}
    >
      <Table size="small">
        <TableHead>
          <TableRow
            onClick={(event) => event.stopPropagation()}
            className="inner-table-header"
          >
            {Object.values(innerTableHeaders).map((headerItem, index) => (
              <TableCell key={index}>{t(headerItem)}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {samples.map((sampleData, index) => (
            <SampleRow
              key={index}
              userObj={userObj}
              sampleData={sampleData}
              rowData={rowData}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
